export const PAPER_UI_TERMS = {
    header: {
        title: 'Structuring Line Ensembles',
        subtitle: 'Path-Integrated Fidelity and Structural Inconsistency Fields',
    },
    panels: {
        fieldParameters: 'Field Parameters',
        viewSettings: 'View Settings',
        focusContextViewSettings: 'Focus+Context View',
        figureResolution: 'Figure Resolution',
        lineEnsembleInput: 'Line Ensemble Input',
        figureExport: 'Figure Export',
        queryResultAnalysis: 'Query Result Analysis',
        queryResultRefinement: 'Query Result Refinement',
        subsetExtraction: 'Subset Extraction',
        extractedSubsets: 'Extracted Subsets',
        selectedSubsetView: 'Selected Subset View',
    },
    controls: {
        pathExtent: 'Path Extent (ell)',
        gridResolution: 'Bin Size',
        view: 'View',
        colormap: 'Colormap',
        histogramEqualization: 'Histogram Equalization',
        densityPlot: 'Density Plot',
        structuralInconsistencyField: 'Structural Inconsistency Field',
        focusContextView: 'Focus+Context View',
        linesOnly: 'Lines Only',
        lineOpacity: 'Line Opacity',
        inconsistencyThreshold: 'Inconsistency Threshold',
        transitionWidth: 'Transition Width',
        contextDesaturation: 'Context Desaturation',
        saveMainView: 'Save Main View (PNG)',
        loadLineEnsemble: 'Load Line Ensemble (.csv)',
        applyFigureResolution: 'Apply Figure Resolution',
        resetFieldSettings: 'Reset Field Settings',
    },
    query: {
        windowQuery: 'Window Query',
        timeBox: 'TimeBox',
        windowQueryTooltip: 'Window Query: select lines intersecting the query window',
        timeBoxTooltip: 'TimeBox: retain lines entering from the left boundary and exiting from the right boundary',
        queryTips: 'Query Tips',
        drawQueryWindow: 'Drag to draw a query window',
        panView: 'Pan view',
        zoomView: 'Scroll to zoom',
        clearQuery: 'Clear query',
        queryCleared: 'Query cleared',
        toggleOverlays: 'Press H to toggle overlays',
        showOverlays: 'Press H to show overlays',
        queryResult: 'Query Result',
        queryWindow: 'query window',
        queryAnalysis: 'query analysis',
    },
    subset: {
        subset: 'Subset',
        subsets: 'Subsets',
        active: 'Active',
        retained: 'Retained',
        retainedShare: 'Retained Share',
        retainByPercentile: 'Retain by Trajectory-Fidelity Percentile',
        queryResultOpacity: 'Query Result Opacity',
        lowerRanked: 'Lower trajectory-fidelity scores',
        higherRanked: 'Higher trajectory-fidelity scores',
        dragToExtractSubset: 'Drag to Extract Subset',
        releaseToCreateSubset: 'Release to create subset',
        dropToExtractSubset: 'Drop here to extract a subset',
        creatingSubset: 'Creating subset...',
    },
    status: {
        noQueryResult: 'No query result available',
        beginWithQueryWindow: 'Draw a query window in the main view to begin analysis',
        queryResultLines: 'Lines in Query Result',
        refineQueryResult: 'Refine the query result and extract subsets',
        queryAnalysisPending: 'Computing trajectory-fidelity scores...',
        queryAnalysisUnavailable: 'Trajectory-fidelity scores are unavailable for this query result.',
        queryAnalysisMinimum: 'Trajectory-fidelity scores require at least 3 lines.',
        reloadingNeeded: 'Figure resolution updated. Reload the line ensemble to apply it.',
        ensembleUpdated: 'Line ensemble updated',
        mainViewNotReady: 'Main view not ready',
        figureSaved: 'Main view saved successfully',
        savingFigure: 'Saving main view...',
        figureSaveFailed: 'Failed to save the main view',
        imageGenerationFailed: 'Failed to generate the figure image',
        rendererNotReady: 'Main view renderer not ready',
        noLinesRemaining: 'No lines remain in the line ensemble',
        loadingMainView: 'Initializing main view...',
        preparingBins: 'Preparing line ensemble bins...',
        initializingFieldScan: 'Initializing structural field scan...',
        initializingRenderer: 'Initializing rendering pipeline...',
        computingField: 'Computing structural inconsistency field...',
        refreshingFieldView: 'Refreshing field view...',
        updatingFocusContextView: 'Updating focus+context view...',
        queryScoringFailed: 'Failed to score the query result',
        rendererInitFailed: 'Failed to initialize the main view renderer',
        lineEnsembleViewUpdateFailed: 'Failed to update the line ensemble view',
    },
} as const;
